module.exports = __webpack_public_path__ + "static/media/TAWFullLogo.d775ebad.svg";